import "./TeenpattiTestPL.scss";
import React, { useEffect, useState } from 'react'

const TeenpattiTestPL = ({roundMarkets}) => {
 let [winnerData, setWinnerData] = useState(null);

 const getWinner = () => {
   const winObj = {
     others: '',
   };

   if (roundMarkets.length > 0) {
     roundMarkets.forEach((market) => {
       market.marketRunner.forEach((runner) => {
         if (runner.status === 'WINNER') {
           winObj[market.marketHeader] = runner.name;
         }
         if (market.marketHeader !== 'Match Odds' && runner.status === 'WINNER' && runner.name !== 'No Winner') {
           winObj.others = winObj.others.length <= 3 ?
             `${runner.name[0]} : ${market.marketHeader}`
             :
             `${winObj.others} | ${runner.name[0]} : ${market.marketHeader}`;
         }
       });
     });
   }
   setWinnerData(winObj)
  }
  useEffect(() => {
    getWinner()
  }, [roundMarkets]);

  const cardSrc = (card) => {
    if (card) {
      return `https://stream.fawk.app/assets/smallCards/${card}.png`;
    } else {
      return "https://stream.fawk.app/assets/smallCards/BACK.png";
    }
  };

    return (
      <div className="teenpatti-test-betting">
        <div className="teenpatti-test-betting__games">
          <div className="teenpatti-test-betting__games-item">
            <span
              className={`teenpatti-test-betting__games-item-title ${roundMarkets[0].marketRunner[0].status === 'WINNER' ? 'winnerCup':''}`}>
              Tiger
            </span>
            <div className="teenpatti-test-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[0]?.cards.map( card =>
                <img className="teenpatti-test-betting__games-item-cards-card"
                     key={card}
                     src={cardSrc(card)}
                     alt={card}
                />
              )}
            </div>
          </div>
          <div className="teenpatti-test-betting__games-item">
            <span
              className={`teenpatti-test-betting__games-item-title ${roundMarkets[0].marketRunner[1].status === 'WINNER' ? 'winnerCup':''}`}>
                Lion
            </span>
            <div className="teenpatti-test-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[1]?.cards.map( card =>
                <img className="teenpatti-test-betting__games-item-cards-card"
                     key={card}
                     src={cardSrc(card)}
                     alt={card}
                />
              )}
            </div>
          </div>
          <div className="teenpatti-test-betting__games-item">
            <span
              className={`teenpatti-test-betting__games-item-title ${roundMarkets[0].marketRunner[2].status === 'WINNER' ? 'winnerCup':''}`}>
                Dragon
            </span>
            <div className="teenpatti-test-betting__games-item-cards">
              {roundMarkets && roundMarkets[0].marketRunner[2]?.cards.map( card =>
                <img className="teenpatti-test-betting__games-item-cards-card"
                     key={card}
                     src={cardSrc(card)}
                     alt={card}
                />
              )}
            </div>
          </div>
        </div>
        {winnerData && <div className="teenpatti-test-betting__info-column">
          <div className="teenpatti-test-betting__info-row">
            <div className="teenpatti-test-betting__info-row-title">
              <span>Winner: </span>
            </div>
            <div className="teenpatti-test-betting__info-row-results">
              <span>{winnerData['Match Odds'] || 'No Winner'}</span>
            </div>
          </div>
          <div className="teenpatti-test-betting__info-row">
            <div className="teenpatti-test-betting__info-row-title">
              <span>Others: </span>
            </div>
            <div className="teenpatti-test-betting__info-row-results">
              <span>
                {winnerData['others'] || 'No Winner'}
              </span>
            </div>
          </div>
        </div>}
      </div>

    );
};

export default TeenpattiTestPL;

